import { render, staticRenderFns } from "./FolderPreview.vue?vue&type=template&id=316af354&scoped=true&"
import script from "./FolderPreview.vue?vue&type=script&lang=js&"
export * from "./FolderPreview.vue?vue&type=script&lang=js&"
import style0 from "./FolderPreview.vue?vue&type=style&index=0&id=316af354&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316af354",
  null
  
)

export default component.exports